<template>
    <div>
        <h2 class="pb-6">{{ $t('Анонсы') }}</h2>
        
        <div class="page-inner">
            <div class="row mt--2">
                <div class="col-lg-12">
                    <v-card v-if="data" class="mx-auto" elevation="1">
                        <v-img
                        :src="data.image"
                        height="300px"
                        ></v-img>

                        <v-card-title>
                            {{ data.title }}
                        </v-card-title>

                        <v-card-subtitle>
                            {{ data.created_at }}
                        </v-card-subtitle>

                        <v-card-text class="black--text" style="font-size: 16px">
                            {{ data.body }}
                        </v-card-text>
                    </v-card>
                    
                    <v-progress-circular
                        v-else
                        indeterminate
                        :width="3"
                        class="mb-3"
                        color="primary"
                    ></v-progress-circular>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        components: { 
        },
        mounted() {
            this.getData();
        },
        data: () => ({
            data: null
        }),
        methods: {
            async getData() {
                await this.$http.get('/announce/list/'+this.$route.params.id).then((response) => {
                    this.data = response.data.data;
                }).catch(() => {});
            }
        }
    }
</script>

<style scoped>

</style>